/**
 * @desc  格式化时间
 * @param {(Object|string|number)} time
 * @param {string} format
 * @returns {string | null}
 */
// export function formatDateTime(time = undefined, format = 'YYYY-MM-DD HH:mm:ss') {
//   return dayjs(time).format(format)
// }

// export function formatDate(date = undefined, format = 'YYYY-MM-DD') {
//   return formatDateTime(date, format)
// }

/**
 * @desc  函数节流
 * @param {Function} fn
 * @param {Number} wait
 * @returns {Function}
 */
export function throttle(fn, wait) {
  var context, args
  var previous = 0

  return function () {
    var now = +new Date()
    context = this
    args = arguments
    if (now - previous > wait) {
      fn.apply(context, args)
      previous = now
    }
  }
}

/**
 * @desc  函数防抖
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(method, wait, immediate) {
  let timeout
  return function (...args) {
    let context = this
    if (timeout) {
      clearTimeout(timeout)
    }
    // 立即执行需要两个条件，一是immediate为true，二是timeout未被赋值或被置为null
    if (immediate) {
      /**
       * 如果定时器不存在，则立即执行，并设置一个定时器，wait毫秒后将定时器置为null
       * 这样确保立即执行后wait毫秒内不会被再次触发
       */
      let callNow = !timeout
      timeout = setTimeout(() => {
        timeout = null
      }, wait)
      if (callNow) {
        method.apply(context, args)
      }
    } else {
      // 如果immediate为false，则函数wait毫秒后执行
      timeout = setTimeout(() => {
        /**
         * args是一个类数组对象，所以使用fn.apply
         * 也可写作method.call(context, ...args)
         */
        method.apply(context, args)
      }, wait)
    }
  }
}

/**
 *
 * @param {HTMLElement} el
 * @param {Function} cb
 * @return {ResizeObserver}
 */
export function useResize(el, cb) {
  const observer = new ResizeObserver((entries) => {
    cb(entries[0].contentRect)
  })
  observer.observe(el)
  return observer
}

/**
 * 数组随机排序
 * @param {*} arr 数组
 * @returns 排序数组
 */
export function randomSort(arr) {
  const result = []
  const len = arr.length
  for (let i = 0; i < len; i++) {
    const index = Math.floor(Math.random() * arr.length)
    result.push(arr[index])
    arr.splice(index, 1)
  }
  return result
}

/**
 * 对象参数转URL
 * @param {Object} data 参数对象
 */
export function parseParams(data) {
  try {
    const tempArr = []
    for (let i in data) {
      const key = encodeURIComponent(i)
      const value = encodeURIComponent(data[i])
      tempArr.push(key + '=' + value)
    }
    return tempArr.join('&')
  } catch (err) {
    return ''
  }
}

/**
 * 深度拷贝
 * @param {Object} obj 
 * @returns Object
 */
export function deepCopy(obj) {
  if (typeof obj !== 'object') {
    return obj
  }
  const newObj = obj instanceof Array ? [] : {}
  for (let key in obj) {
    newObj[key] = typeof obj[key] === 'object' ? deepCopy(obj[key]) : obj[key]
  }
  return newObj
}

export const isHTMLBalanced = (html) => {
  // 正则表达式匹配<h1>到<h6>的开始和结束标签
  const tagPattern = /<\/?h[1-6]?>?/g;
  
  // 用于存储标签的栈
  const stack = [];
  
  // 找到所有标签
  const tags = html.match(tagPattern);
  
  if (!tags) {
    // 如果没有标签，则认为是闭合的
    return true;
  }
  for (let tag of tags) {
    if (tag.startsWith('</')) {
      // 如果是结束标签，则检查栈顶元素是否匹配
      const startTag = stack.pop();
      const expectedTag = tag.replace('/', '');
      if (startTag !== expectedTag) {
        // 如果不匹配，表示标签未正确闭合
        return false;
      }
    } else {
      // 如果是开始标签，则推入栈中
      stack.push(tag);
    }
  }
  
  // 如果栈为空，则所有标签都正确闭合
  return stack.length === 0;
}

export const parseHTMLToJSON = (htmlContent) => {
  // 用于存储最终的JSON数组
  const result = [];
  // 用于跟踪当前的节点层级
  let currentHierarchy = [{ children: result }];

  // 正则表达式，用于匹配标题标签和内容
  const tagRegex = /<(h[1-6])>([^<]+)<\/\1>|([^<]+)/g;
  let match;

  // 循环匹配文本中的标题标签和内容
  while ((match = tagRegex.exec(htmlContent)) !== null) {
    let [fullMatch, tag, title, content] = match;

    // 如果找到标题标签
    if (tag) {
      const level = parseInt(tag[1]); // 标题的层级，例如h1 -> 1
      const newItem = {
        status: true,
        title: title.trim(),
        content: "",
        children: []
      };

      // 截断当前层级到当前标题标签的层级
      currentHierarchy = currentHierarchy.slice(0, level);
      // 获取当前层级的最后一个元素，即父级对象
      const parentItem = currentHierarchy[level - 1];
      // 将新的标题对象添加到父级的children中
      parentItem.children.push(newItem);
      // 更新当前层级，将新的标题对象添加进去
      currentHierarchy[level] = newItem;
    } else if (content) {
        // 如果找到内容而没有标题标签
        content = content.trim();
        if (content) {
          // 如果当前层级为空，则创建一个无标题的对象
          if (currentHierarchy.length === 1) {
            result.push({
              status: true,
              title: "",
              content: content,
              children: []
            });
          } else {
            // 否则，将内容添加到当前层级的最后一个标题对象中
            const currentItem = currentHierarchy[currentHierarchy.length - 1];
            currentItem.content += (currentItem.content ? " " : "") + content;
          }
        }
      }
    }

  return result;
}
export const validatePhoneNumber = (phoneNumber) => {
  // 国内手机号的简单验证规则
  const phoneRegex = /^1[3-9]\d{9}$/;
  return phoneRegex.test(phoneNumber);
}

  // 获取url参数对象
export const getUrlParams = (url) => {
  const search = url || window.location.search
  const params = new URLSearchParams(search)
  const obj = {}
  for (const key of params.keys()) {
    obj[key] = params.get(key)
  }
  return obj
}

// 操作localstroe
export const storage = {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get(key) {
    return JSON.parse(localStorage.getItem(key))
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  clear() {
    localStorage.clear()
  }
}

export const sleep = (time) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

/**
 * @desc  图片路径（本地public、src/assets或网络）转base64
 * @param {string} url 图片路径或URL
 * @returns {Promise<string>} base64字符串
 * @example
 * // public目录图片
 * imagePathToBase64('/staticPicture1.jpg').then(base64 => { console.log(base64) })
 * // src/assets目录图片（需import获取路径）
 * import myImg from '@/assets/images/bg.svg'
 * imagePathToBase64(myImg).then(base64 => { console.log(base64) })
 * // 网络图片
 * imagePathToBase64('https://example.com/image.jpg').then(base64 => { console.log(base64) })
 */
export function imagePathToBase64(url) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.crossOrigin = 'Anonymous'; // 允许跨域（如有CORS）
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = function (e) {
      reject(e);
    };
    img.src = url;
  });
}

/**
 * 将 px 转换为以 375px 为基准的 vw 单位
 * @param {number} pxValue - 设计稿中的像素值（如 187.5px）
 * @returns {string} 转换后的 vw 字符串（如 "50vw"）
 */
export function pxToVw(pxValue, designWidth = 375) {
  // 计算 vw 值：(pxValue / 设计稿宽度) * 100
  const vwValue = (pxValue / designWidth) * 100;

  // 保留 5 位小数（可根据需求调整精度）
  const roundedVw = vwValue.toFixed(2);

  return `${roundedVw}vw`;
}

// 埋点用户类型
export function sensorUserType(type){
  const typeMap = {
    1: 'registered',
    2: 'self_joined',
    3: 'class_bound'
  }

  return typeMap[type] || 'guest'
}